// extracted by mini-css-extract-plugin
export default {"inlineButtonsConfirmation":"importInDesignConfirmation_inlineButtonsConfirmation__+XGzX"};